import React from 'react';
// Import image directly using ES import
import orthoHillImage from '../../../assets/images/ortho-hill.jpeg';

const VegetationAnalysis = () => {
    return (
        <div className="analysis-section">
            <div className="analysis-content">
                <h2>Vegetation Analysis & Inventory</h2>
                <p>
                    Our comprehensive Vegetation Analysis services transform LiDAR data into detailed forest structural assessments, providing unprecedented insights for sustainable resource management, conservation planning, and environmental monitoring.
                </p>
                <p>
                    Using proprietary classification algorithms, we extract individual tree parameters including height, crown diameter, biomass, and species distribution. Our analysis goes beyond traditional inventory methods by creating spatially explicit 3D models of forest structure that capture both horizontal and vertical complexity.
                </p>
                <p>
                    From calculating carbon sequestration potential to assessing wildfire risk and planning timber harvests, our vegetation analysis provides the quantitative metrics and visualizations needed to make data-driven decisions about natural resource management, biodiversity conservation, and climate adaptation strategies.
                </p>
                <div className="analysis-features">
                    <span className="feature-item">Canopy Height Models</span>
                    <span className="feature-item">Individual Tree Detection</span>
                    <span className="feature-item">Biomass Estimation</span>
                    <span className="feature-item">Habitat Modeling</span>
                    <span className="feature-item">Forest Inventory</span>
                </div>
            </div>
            <div className="analysis-image">
                <img src={orthoHillImage} alt="LiDAR Vegetation Analysis of Residential Hillside Area" />
            </div>
        </div>
    );
};

export default VegetationAnalysis;